import React from 'react';
import MetricSection from './MetricSection';
import SourceFooter from './SourceFooter';
import { ChartPanel, datasetById, MetricCallout, SnapshotBars } from './SectionElements';

const MODE_COLORS = ['#153f78', '#486e9d', '#11998e', '#cad5df', '#73b9ad', '#d4853f'];

const EconomicDiffusionSection = ({ datasets, isZh = false }) => {
    const exposure = datasetById(datasets, 'anthropic_occupation_usage');
    const collaboration = datasetById(datasets, 'anthropic_collaboration');
    const artifacts = datasetById(datasets, 'anthropic_artifact_mix');
    const automatedShare = collaboration.series
        .filter((point) => ['directive', 'feedback_loop'].includes(point.mode))
        .reduce((sum, point) => sum + point.value, 0);

    return (
        <MetricSection
            id="economic-diffusion"
            index={5}
            title="AI Economic Diffusion"
            titleZh="职业与行业渗透"
            summary="Show where AI work is already observed, how people collaborate with it, and what concrete outputs leave the workflow."
            summaryZh="看 AI 已经进入哪些职业任务、人如何与它协作，以及最终带走的是解释、文档还是其他可交付成果。"
            isZh={isZh}
        >
            <div className="ai-dev-callout-row ai-dev-callout-row--compact">
                <MetricCallout value={`${exposure.series[0].value.toFixed(0)}%`} label={isZh ? '最高观察暴露度' : 'highest observed exposure'} note={exposure.series[0].occupation} />
                <MetricCallout value={`${automatedShare.toFixed(0)}%`} label={isZh ? '指令式 + 反馈循环' : 'directive + feedback loop'} note={isZh ? '不是岗位替代率' : 'not a displacement rate'} />
                <MetricCallout value="93%" label={isZh ? '产生明确 Artifact' : 'produced an artifact'} note="Chat + Cowork · 2026-04/06" />
            </div>
            <div className="ai-dev-grid ai-dev-grid--diffusion">
                <ChartPanel eyebrow={isZh ? '职业暴露' : 'OCCUPATIONAL EXPOSURE'} title={isZh ? '观察到 AI 使用最深的职业' : 'Occupations with deepest observed use'} note={isZh ? 'Claude 使用 × 理论可行性 × 任务时间' : 'Claude-observed measure'}>
                    <SnapshotBars rows={exposure.series} labelKey="occupation" valueFormatter={(value) => `${value.toFixed(1)}%`} color="#153f78" max={100} />
                    <SourceFooter dataset={exposure} isZh={isZh} />
                </ChartPanel>
                <div className="ai-dev-stack">
                    <ChartPanel eyebrow={isZh ? '协作方式' : 'COLLABORATION MODES'} title={isZh ? '人与 AI 如何分工' : 'How people divide work with AI'} note={isZh ? '分类器口径快照' : 'classifier snapshot'}>
                        <div className="ai-dev-stacked-bar" role="img" aria-label="Claude collaboration mode shares">
                            {collaboration.series.map((point, index) => (
                                <i key={point.mode} style={{ width: `${point.value}%`, background: MODE_COLORS[index] }} title={`${point.mode}: ${point.value}%`} />
                            ))}
                        </div>
                        <div className="ai-dev-mode-legend">
                            {collaboration.series.map((point, index) => (
                                <span key={point.mode}><i style={{ background: MODE_COLORS[index] }} />{point.mode.replaceAll('_', ' ')} <strong>{point.value.toFixed(1)}%</strong></span>
                            ))}
                        </div>
                        <SourceFooter dataset={collaboration} isZh={isZh} />
                    </ChartPanel>
                    <ChartPanel eyebrow={isZh ? '最终产出' : 'OUTPUTS'} title={isZh ? '最常见的对话产物' : 'Most common conversation artifacts'} note={isZh ? 'Top 3；非完整分布' : 'top 3, not exhaustive'}>
                        <SnapshotBars rows={artifacts.series} labelKey="artifact" valueFormatter={(value) => `${value}%`} color="#11998e" max={20} />
                        <SourceFooter dataset={artifacts} isZh={isZh} />
                    </ChartPanel>
                </div>
            </div>
        </MetricSection>
    );
};

export default EconomicDiffusionSection;
